import type { SupabaseClient } from '@supabase/supabase-js';

// 로그아웃 — 서버가 거절해도 이 기기의 로그인 정보는 지운다 (2026-10-28 탈퇴 문의 '로그아웃 버튼도 정상적으로 작동하지 않습니다')
// supabase-js는 서버 로그아웃 응답이 401·403·404일 때만 기기의 로그인 정보를 지우고, 그 밖의 오류(500 등)면 그대로 둔다.
// 탈퇴 직후 계정은 로그인 서버가 500을 내 화면이 로그인 상태로 멈췄다(원인 수리: 20261028201500_anonymize_ban_finite_date).
// → 저장된 로그인 정보를 직접 지운 뒤, 서버를 부르지 않는 기기 로그아웃으로 'SIGNED_OUT'을 알려 화면 상태(useAuthStore 등)도 비운다.
export async function signOutWithLocalFallback(client: SupabaseClient, supabaseUrl: string): Promise<void> {
    const { error } = await client.auth.signOut();
    if (!error) return;

    console.warn('⚠️ 서버 로그아웃 실패 - 이 기기의 로그인 정보만 지웁니다:', error.message);
    // supabase-js 기본 저장 이름과 같은 규칙(sb-<프로젝트>-auth-token)
    const storageKey = `sb-${new URL(supabaseUrl).hostname.split('.')[0]}-auth-token`;
    try {
        window.localStorage.removeItem(storageKey);
    } catch {
        // 저장소 접근이 막힌 브라우저 — 아래 기기 로그아웃이 다시 지운다
    }
    // 저장된 세션이 없으니 서버를 부르지 않고 기기 정보 정리 + SIGNED_OUT 알림만 한다
    const { error: localError } = await client.auth.signOut({ scope: 'local' });
    if (localError) throw localError;
}
